<div class="card-body">
    <h4 class="card-title">
        <span class="badge badge-info badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </h4>
    <div class="d-md-flex align-items-center bg-white p-2">
        <a href="javascript:void(0)" (click)="filtroAperte()" class="d-flex align-items-center p-2 rounded-pill bg-light">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Attivita aperte:</h5>
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{openedCollectionSize}}</span>
    </a>
    &nbsp;
    <a href="javascript:void(0)" (click)="filtroConcluse()" class="d-flex align-items-center p-2 rounded-pill bg-light">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Attivita concluse:</h5>
      <span class="badge badge-success badge-pill px-3 font-weight-bold font-14">{{closedCollectionSize}}</span>
    </a>
        <div class="ml-auto mt-3 mt-md-0">
            <button type="button" (click)="openModal(CRMModal)" class="btn btn-cyan rounded-pill p-2"><i
                    class="fas fa-plus  font-14 mr-1 text-white"></i>
                <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
            </button>
        </div>
    </div>
    <div class="table-responsive">
        <table class="table bg-white table-hover align-middle mb-0">
            <thead>
                <tr>
                    <th scope="col">Attivita</th>
                    <th scope="col">Stato</th>
                    <th scope="col">Data</th>
                    <th scope="col">Responsabile</th>
                    <th scope="col">Note</th>
                    <th scope="col">Azioni</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of AttivitaFiltrate">
                    <td class="align-middle" (click)="openEditModal(CRMModal, item)">
            <span class=" text-dark font-medium font-16">
              <span class="badge badge-light text-orange rounded-pill font-16 mr-1">
                <i-feather name="activity" class="feather-sm"></i-feather>
              </span>
              {{ item.attivita}}
            </span>
          </td>
                    <td class="align-middle " (click)="openEditModal(CRMModal, item)">
            <span *ngIf="item.att_chiusa"  class="label label-success"> Chiuso </span>
            <span *ngIf="!item.att_chiusa" class="label label-danger"> Aperta </span>
          </td>
                    <td class="align-middle" (click)="openEditModal(CRMModal, item)">
                        <span>
                            <span class="badge badge-light  rounded-pill font-16 mr-1"
                                style="color: rgb(116, 96, 238);">
                                <i class="fas fa-calendar"></i>
                            </span>
                            {{ item.data_attivita | date: 'dd/MM/yyyy HH:mm'}}
                        </span>
                    </td>
                    <td class="align-middle " (click)="openEditModal(CRMModal, item)">
                        <span>
                            <span class="badge badge-light text-info rounded-pill font-16 mr-1">
                                <i class="fas fa-user"></i>
                            </span>
                            {{ item?.responsabile?.fullName}}
                        </span>
                    </td>
                    <td class="align-middle" style="width: 40%; word-break:break-word"
                        (click)="openEditModal(CRMModal, item)">
                        <span>
                            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                                <i-feather name="info" class="feather-sm"></i-feather>
                            </span>
                            {{ item.note}}
                        </span>
                    </td>
                    <td class="align-middle">

                        <a href="javascript:void(0)" class="link text-info font-16 font-medium mr-2"
                            (click)="openEditModal(CRMModal, item)">
                            <i-feather name="edit-3" class="feather-sm"></i-feather>
                        </a>
                        <a href="javascript:void(0)" class="link font-16 text-danger font-weight-bold"
                            (click)='delete(item)'>
                            <i-feather name="trash-2" class="feather-sm"></i-feather>
                        </a>
                        <a *ngIf=" item.allegato !== '' " href="javascript:void(0)"
                            class="link  font-16 font-weight-bold mr-2" (click)='download(item)'>
                            <i-feather name="download" class="feather-sm"></i-feather>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-template #CRMModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="editUserLabel">{{EnvData.label}}</h5>
        <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-field-viewer [(Campi)]="EnvData.Campi" [(Oggetto)]="AttivitaSelezionata"></app-field-viewer>
    </div>
    <div class="modal-footer">
        <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
            <button (click)="saveModalButton()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
                <span class="ml-1 text-white font-weight-bold"> Salva </span>
                <i-feather name="save" class="feather-md "></i-feather>
            </button>
        </div>
    </div>
</ng-template>

